import AddUpdateAutomationModal from './modal/add_update_workflow';
import { AutomationObject } from '../../params/redux/automation';
import CustomInput from '../reusable/input';
import { fetchAutomationThunk } from '../../redux/thunks/automation';
import { green } from '../../theme/themePrimitives';
import { useParams } from 'react-router';
import WorkFlowCardComponent from './workflow_card';
import { Add, Search, Sort } from '@mui/icons-material';
import { AppDispatch, RootState } from '../../redux/store';
import { Box, Button, CircularProgress, InputAdornment, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';

const AutomationComponent = () => {
    const dispatch = useDispatch<AppDispatch>();
    const { id } = useParams<{ id: string }>();
    const { automations, loaders } = useSelector((state: RootState) => state.automation);
    const [search, setSearch] = useState<string>('');
    const [sort, setSort] = useState<boolean>(false);
    const [showModal, setShowModal] = useState<boolean>(false);
    const activeWorkflowsCount = automations.filter((automation: AutomationObject) => automation.status === 'active').length;
    const filteredAutomation = automations.filter((automation: AutomationObject) => {
        const name = automation.automation_name.toLowerCase().trim();
        const pipeline_name = automation.pipeline_name?.toLowerCase() || '';
        const stage_name = automation.stage_name?.toLowerCase() || '';
        return (
            !search ||
            name.includes(search.toLowerCase()) ||
            pipeline_name.includes(search.toLowerCase()) ||
            stage_name.includes(search)
        );
    });

    const sortedAutomations = sort
        ? [...filteredAutomation].sort((a, b) => a.automation_name.localeCompare(b.automation_name))
        : filteredAutomation;

    useEffect(() => {
        const fetchWorkFlow = async () => {
            try {
                await dispatch(fetchAutomationThunk(id ? parseInt(id as string, 10) : 0)).unwrap();
            } catch (e) {
                // Catch errors
            }
        };
        fetchWorkFlow();
    }, [id]);

    return <Box minHeight="75vh">
        <Box display="flex" gap={2} my={2}>
            <Typography variant="h4" color="textSecondary" >Workflows</Typography>
            <Box bgcolor={green[100]} px={2} py={1} borderRadius={1} color={green[400]}>
                <Typography fontWeight="bold" variant="body2">Active Workflows - {activeWorkflowsCount}</Typography>
            </Box>
        </Box>
        <Box display="flex" justifyContent="space-between" alignItems="center">
            <Box display="flex" gap={1} alignItems="center">
                <CustomInput
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    slotProps={{
                        input: {
                            startAdornment: <InputAdornment position="start">
                                <Search />
                            </InputAdornment>
                        }
                    }}
                    placeholder="Search..."
                />
                <Button variant="outlined" color={sort ? 'primary' : 'secondary'} startIcon={<Sort />} onClick={() => setSort(!sort)}>
                    Sort
                </Button>
            </Box>
            <Button variant="contained" startIcon={<Add />} onClick={() => setShowModal(true)}>Add new automation</Button>
        </Box>
        <Box display="flex" minHeight="65vh" flexWrap="wrap" justifyContent={loaders.isLoading ? 'center' : 'start'} alignItems={loaders.isLoading ? 'center' : 'start'} gap={2} mt={2} overflow="auto">
            {
                loaders.isLoading
                    ? <Box display="flex" alignItems="center" flexDirection="column" height="200px" justifyContent="center">
                        <CircularProgress />
                        <Typography variant="body2">Loading...</Typography>
                    </Box>
                    : sortedAutomations.map((automation: AutomationObject) => (
                        <Box minWidth="445px" key={automation.id}>
                            <WorkFlowCardComponent automation={automation} />
                        </Box>
                    ))
            }
        </Box>
        <AddUpdateAutomationModal open={showModal} onClose={() => setShowModal(false)} />
    </Box>;
};

export default AutomationComponent;